import React from 'react';
import { cn } from '../lib/utils';
interface ContactFooterProps {
  className?: string;
  id?: string;
}
export function ContactFooter({
  className,
  id
}: ContactFooterProps) {
  return <footer id={id} className={cn('reveal-section w-full py-32 md:py-48 flex flex-col items-center justify-center text-center px-6', className)} data-id="element-1">
      <div className="space-y-8 max-w-2xl" data-id="element-2">
        <div data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-light tracking-widest mb-2" data-id="element-4">
            <span className="text-coral" data-id="element-5">sic</span>{' '}
            <span className="text-muted-foreground" data-id="element-6">/</span> Akshay Gite
          </h2>
          <p className="font-mono text-sm text-muted-foreground tracking-widest uppercase" data-id="element-7">
            Sound artist, composer, designer, researcher
          </p>
        </div>

        <div className="pt-8 pb-12" data-id="element-8">
          <a href="mailto:akshaysic@gmail.com" className="text-lg md:text-xl text-foreground hover:text-coral transition-colors duration-500 tracking-wide" data-id="element-9">
            akshaysic@gmail.com
          </a>
        </div>

        <div className="w-full max-w-md mx-auto p-6 border border-orange-500/40 rounded-lg bg-orange-500/5 backdrop-blur-sm mb-12 hover:border-orange-500/70 hover:bg-orange-500/10 transition-all duration-500" data-id="element-10">
          <a href="https://on.soundcloud.com/PlF2OtLQXOPBFzUeKi" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center space-x-3 text-orange-400 hover:text-orange-300 transition-colors" data-id="element-11">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-12">
              <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" data-id="element-13"></polygon>
              <path d="M15.54 8.46a5 5 0 0 1 0 7.07" data-id="element-14"></path>
              <path d="M19.07 4.93a10 10 0 0 1 0 14.14" data-id="element-15"></path>
            </svg>
            <span className="font-mono text-sm tracking-widest uppercase" data-id="element-16">
              Listen on SoundCloud
            </span>
          </a>
        </div>

        <p className="text-sm text-muted-foreground/60 italic tracking-wide max-w-lg mx-auto leading-relaxed" data-id="element-17">
          Available for residencies, spatial sound performances, and artistic
          research collaborations.
        </p>
      </div>
    </footer>;
}